var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogOutNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 17.7715H4.66667C4.22464 17.7715 3.80072 17.5959 3.48816 17.2833C3.17559 16.9708 3 16.5468 3 16.1048V4.43815C3 3.99612 3.17559 3.5722 3.48816 3.25964C3.80072 2.94708 4.22464 2.77148 4.66667 2.77148H8M13.8333 14.4382L18 10.2715M18 10.2715L13.8333 6.10482M18 10.2715H8",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogOutNew);
export default __webpack_public_path__ + "static/media/LogOutNew.6b0c1d3c4ade8e4a581c59d9bf67742d.svg";
export { ForwardRef as ReactComponent };